import React from "react";
// Import the same hook we used for the CEO
import { useImage } from "../hooks/useImage";

// 1. Create a small sub-component for each individual staff member
const StaffMember = ({ docId }) => {
  const { imageUrl, loading, error } = useImage(docId);

  if (loading) {
    return (
      <div className="aspect-w-3 aspect-h-4 rounded-xl bg-white/10 animate-pulse shadow-lg" />
    );
  }

  if (error || !imageUrl) {
    return null; // Don't show anything if the ID is wrong or fetch fails
  }

  return (
    <div className="group relative aspect-w-3 aspect-h-4 overflow-hidden rounded-xl shadow-2xl transition-all duration-300 hover:scale-105">
      <img
        src={imageUrl}
        alt="Staff Member"
        className="h-full w-full object-cover object-center"
      />
      {/* Visual polish: a slight dark overlay that appears on hover */}
      <div className="absolute inset-0 bg-black opacity-0 transition-opacity duration-300 group-hover:opacity-20" />
    </div>
  );
};
// ... (keep StaffMember sub-component exactly as it is)

export default function Staff() {
  const staffDocIds = [
    "eWCpycY3qhz4xkBg4xpN",
    "v2JGB17GvJDh4EmNcNNL",
    "9yjb35AJQ6xfaybwGLuN",
    "MZttsJcWJhEBmjSeY1ua",
    "MXpe2narye9Pgv6nzxW9"
  ];

  return (
    <section className="bg-custom-rose py-16 px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Our Care Team
          </h2>
          <p className="mt-4 text-lg text-gray-200">
            The dedicated hands behind every animal's smile.
          </p>
        </div>

        {/* Update the grid classes:
            - flex flex-wrap: Allows for centering logic
            - justify-center: Centers any item that is alone on a row
        */}
        <div className="flex flex-wrap justify-center gap-8">
          {staffDocIds.map((id) => (
            <div key={id} className="w-[calc(50%-1rem)] sm:w-[calc(33.33%-2rem)] lg:w-[calc(20%-2rem)] min-w-[150px]">
               <StaffMember docId={id} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}